<template>
  <div class="row">
    <Preloader v-if="isLoading" customClasses="vh-100" />
    <div class="col-12">
      <FinanceInvoicesForm v-model="invoiceFormData.show" disableAnimation :mode="invoiceFormData.mode"
        :data="invoiceFormData.form" :title="invoiceFormData.title" :headerTitle="invoiceFormData.headerTitle"
        :submitButtonText="invoiceFormData.submitButtonText" :bankDetails="getOwnBankDetails" :templates="getTemplates"
        :projects="getActualProjects" :statuses="getStatuses" :types="getInvoicesTypes"
        @submit="saveFinanceInvoices" @invoiceFormClosed="onClose" @showDownloadModal="showDownloadInvoiceModal"
        @loadingChange="handleInvoiceFormLoadingChange" ref="financeInvoicesForm" />
    </div>

    <!-- Download Invoice Modal -->
    <DownloadInvoiceModal
      v-model="downloadInvoiceModal.show"
      :invoice="downloadInvoiceModal.invoice"
      :templates="getTemplates"
      :triggerElement="downloadInvoiceModal.triggerElement"
    />
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import { PostalNames } from '@/constants/PortalNames'
import Preloader from '@components/Preloader'
import FinanceInvoicesForm from '@components/modals/FinanceInvoicesForm/FinanceInvoicesForm.vue'
import InvoiceFormModal from '../mixins/InvoiceFormModal'
import DownloadInvoiceModal from '@components/modals/DownloadInvoiceModal.vue'

export default {
  name: 'FinanceInvoiceEdit',
  mixins: [ InvoiceFormModal ],
  components: {
    Preloader,
    FinanceInvoicesForm,
    DownloadInvoiceModal
  },
  data () {
    return {
      isLoading: false,
      permissions: permissions,
      isShowBulkCreation: false,
      modalLoading: false,
      PostalNames,
      downloadInvoiceModal: {
        show: false,
        invoice: null,
        triggerElement: null
      }
    }
  },
  async created () {
    this.isLoading = true
    const { id } = this.$route.params
    await this.fetchInvoice(id)

    this.isLoading = false

    await this.fetchInvoiceFormData()
  },
  methods: {
    async fetchInvoice (id) {
      try {
        const resp = await this.$api.finances.getInvoice(id)

        this.showEditInvoice(resp, resp)
      } catch (error) {
        this.errorNotifications(error)
      }
    },
    onClose () {
      this.$router.push({ name: 'finances-invoices' })
    },
    async saveFinanceInvoices (fields) {
      try {
        await this.saveInvoice(fields)
        this.$router.push({ name: 'finances-invoices' })
      } finally {
        // Always turn off loading state
        if (this.$refs.financeInvoicesForm) {
          this.$refs.financeInvoicesForm.finishLoading()
        }
      }
    },
    handleInvoiceFormLoadingChange (loading) {
      // This method handles loading state changes from the invoice form
      // The loading state is now managed internally by the FinanceInvoicesForm component
    },
    showDownloadInvoiceModal (data) {
      this.downloadInvoiceModal.invoice = data.invoice
      this.downloadInvoiceModal.triggerElement = data.triggerElement
      this.downloadInvoiceModal.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.invoices-page {
  ::v-deep th.actions-column {
    padding-left: 24px;
  }
}

.invoices-page :global(.table__theme-default table td) {
  padding-top: 8px;
  padding-bottom: 8px;
}
  .entities-table-row-modal__period,
  .entities-table-row-modal__items{
    padding: 10px;
    margin-bottom: 15px;
    background-color: #eaeaea;
    &:last-child{
      margin-bottom: 0;
    }
  }
</style>
